import React, { useEffect, useState } from "react";
import { useSpring, animated } from '@react-spring/web';

import PopupModal from "/components/PopupModal";

export default function Footer({ 
    data, 
    popupContent, 
    setPopupContent 
}) {

    const [isFooterActive, setIsFooterActive] = useState(false);

    const footerStyle = useSpring({
        transform: isFooterActive ? `translateY(0%)` : `translateY(100%)`,
    });

    return (
        <>
            {popupContent && (
                <PopupModal popupContent={popupContent} setPopupContent={setPopupContent} data={data} />
            )}
            <animated.div className="footer" style={footerStyle}>
                <div className="footer-tab" onClick={() => setIsFooterActive(prevState => !prevState)}>
                    <svg className={'footer-tab-icon ' + (isFooterActive ? 'rotate-svg' : '')}width="22" height="13" viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="Path 886" d="M1 12L11 2L21 12" stroke="white" strokeWidth="2"/>
                    </svg>
                </div>
                <div className="t-cs">
                    <p onClick={() => setPopupContent('termsandconditions')}>Terms & Conditions</p>
                    <p onClick={() => setPopupContent('privacypolicy')}>Privacy Policy</p>
                    <p onClick={() => setPopupContent('cookies')}>Cookies</p>
                </div>
                <p>All Rights Reserved Pfizer, 2024 - Website designed and developed by <a href="https://www.ignitiondg.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>Ignition DG</a></p>
            </animated.div>
        </>
    )
}